const requiredDateInputValidator = (
  message = 'validators.requiredValidator'
) => ({
  validate: (value) => {
    if (!value) {
      return message;
    }

    const pattern = /^[^/]+\/[^/]+$/;
    return pattern.test(value) ? true : message;
  }
});

export default requiredDateInputValidator;
